import React from "react";
import "../Styles/_AddressInformation.css";

const AddressInformation = ({ currentLanguage, address, addressType }) => {
    if (!address || !address.address1) {
        return null;
    }

    const section = currentLanguage.ORDER_PAGE.SHIPPING_TRACKING_ORDER_SUMMARY_SECTION;
    const header = addressType === "BILLING" ? section.BILLING.HEADING : section.SHIPPING.HEADING;

    return (
        <div className="address-information-container allow-focus" tabIndex="0">
            <h2 className="title">{header}</h2>
            <div className="layout vertical address-information-body">
                <span>{`${address.first_name || ""} ${address.last_name || ""}`.trim()}</span>
                <span>
                    {address.address1}
                    {address.address2 && (
                        <React.Fragment>
                            <br />
                            {address.address2}
                        </React.Fragment>
                    )}
                </span>
                <span>{`${address.city || ""}, ${address.province || ""} ${address.zip || ""}`.trim()}</span>
                <span>{address.country}</span>
            </div>
        </div>
    );
};

export default AddressInformation;

